/******/ (() => { // webpackBootstrap
var __webpack_exports__ = {};
/*!************************************!*\
  !*** ./src/assets/js/global-js.js ***!
  \************************************/
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

var GlobalJS = /*#__PURE__*/function () {
  function GlobalJS() {
    _classCallCheck(this, GlobalJS);

    this.elements = {
      anchorLinks: document.querySelectorAll('a[href*="#"]')
    };
  }

  _createClass(GlobalJS, [{
    key: "globalAnchorScroll",
    value: function globalAnchorScroll() {
      if (this.elements.anchorLinks.length) {
        this.elements.anchorLinks.forEach(function (link) {
          var targetId = link.getAttribute('href').slice(1);
          var target = document.getElementById(targetId);

          if (target) {
            link.addEventListener('click', function (e) {
              e.preventDefault();
              var Ycoords = target.getBoundingClientRect().top + window.pageYOffset - 74;
              window.scrollTo({
                top: Ycoords,
                behavior: "smooth"
              });
            });
          }
        });
      }
    }
  }]);

  return GlobalJS;
}();

var globalFunctions = new GlobalJS();
globalFunctions.globalAnchorScroll();
/******/ })()
;